
import indexOf from 'lodash/indexOf';
import pick from 'lodash/pick';
import keys from 'lodash/keys';
import size from 'lodash/size';
import filter from 'lodash/filter';

import { REGISTRATION, CREATE_LINK, UPDATE_LINK, CREATE_PIXEL_SET  } from '../actions/actionTypes';


const GoogleTagManagerMiddleware = (config = {}) => {
  
  // const linkParams = (payload) => {
  //   return {...pick(payload, ['type', 'host', 'is_custom'])}
  // }
  
  const subscription = {
    [REGISTRATION.SUCCESS]: true,
    [CREATE_PIXEL_SET.SUCCESS]: true,
    [CREATE_LINK.SUCCESS]: (payload) => {
      return pick(payload, ['type', 'host', 'is_custom'])
    },
    [UPDATE_LINK.SUCCESS]: (payload) => {
      let has_buttons = false
      const { settings, type } = payload
      if ( type === 'biolink' && settings ){
        has_buttons = size(filter(settings.buttons, 'id')) > 0 || size(filter(settings.messengers, 'id')) > 0
      }
      
      return {...pick(payload, ['type', 'host', 'is_custom']), has_buttons}
    }
  };
  
  return ({ getState, dispatch }) => {
    return next => action => {
      next(action)
      
      const type = action.type
      if ( !(window.dataLayer) || indexOf(keys(subscription), action.type) < 0 )
        return
      
      const state = getState()
      const payload = action.payload
      
      let eventParams = {
        event: type,
        // account_id: state.currentProject.account.id,
        user_id: state.currentUser && state.currentUser.id,
        user_hash: state.currentUser && state.currentUser.hash_id
      }
      
      if (payload.account_id || (state.currentProject && state.currentProject.account))
        eventParams.account_id = payload.account_id || state.currentProject.account
      
      if (payload.account_id)
        eventParams.account_id = payload.account_id
      
      if (payload.id)
        eventParams.object_id = payload.id
      
      if (typeof subscription[type] === 'function'){
        const enrichParams = subscription[type](payload)
        // Don't send event if sub fn returned null
        if (!enrichParams)
          return
        
        eventParams = {...eventParams, ...enrichParams}
      }
      // console.log('eventParams', eventParams)
      window.dataLayer.push(eventParams)
    }
  }
}

export default GoogleTagManagerMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/GoogleTagManagerMiddleware.js